import React from "react";
import BotonRegresar from "./shared/BotonRegresar";

export default function Estafeta({ onBack }) {
  return (
    <div className="container" style={{ marginTop: "3rem", marginBottom: "4rem" }}>
      <div className="card" style={{ padding: "2rem", borderRadius: "20px" }}>
        <h4 className="center-align" style={{ color: "#ef7cab", marginBottom: "2rem" }}>
          Estafeta Contra el Cáncer
        </h4>

        <div className="row">
          {/* PDF CENTRADO EN TODAS LAS VISTAS */}
          <div className="col s12 m12 l8" style={{ marginBottom: "2rem" }}>
            <div
  className="card z-depth-1 estafeta-pdf"
  style={{ borderRadius: "16px", overflow: "hidden" }}
>

              <iframe
                src="/assets/images/estafeta/narrativa.pdf"
                title="Estafeta contra el cáncer"
                width="100%"
                height="100%"
                style={{ border: "none" }}
              ></iframe>
            </div>
          </div>

          {/* IMAGEN IZQUIERDA */}
          <div className="col s12 m6 l4">
            <div className="card z-depth-1" style={{ borderRadius: "16px", overflow: "hidden" }}>
              <img
                src="/assets/images/estafeta/estafeta1.jpeg"
                alt="Estafeta lado 1"
                style={{ width: "100%", height: "auto", objectFit: "cover" }}
              />
            </div>
          </div>

          {/* IMAGEN DERECHA */}
          <div className="col s12 m6 l4">
            <div className="card z-depth-1" style={{ borderRadius: "16px", overflow: "hidden" }}>
              <img
                src="/assets/images/estafeta/estafeta2.jpeg"
                alt="Estafeta lado 2"
                style={{ width: "100%", height: "auto", objectFit: "cover" }}
              />
            </div>
          </div>
        </div>

        <div className="input-field center-align">
          <BotonRegresar onClick={onBack} />
        </div>
      </div>
    </div>
  );
}
